import { Timer } from './timer';

export function delay(delayTime: number): Promise<void> {
	return new Promise((resolve) => Timer.wait(resolve, delayTime));
}
